import React from "react";
import { Outlet } from "react-router-dom";

function AgentLayout() {
  return <Outlet />;
}

export default AgentLayout;
